.editQuizFilter {
	max-width: 164px;

	& :global(.MuiSelect-select):global(.MuiOutlinedInput-input) {
		padding-left: 0;
	}
}

@media (max-width: 768px) {
	.editQuizFilter {
		max-width: unset;
		width: 100%;
	}
}
